/**
 * Maly pasek "WZ bez faktury" (ANEKS 2) - liczby z podsumowanie.wz:
 * w_portalu, z_faktura, bez_faktury, w_systemie_bez_faktury.
 * Klik w "bez faktury" ustawia filtr 'wz_bez_faktury'.
 */
import React from 'react';

const PasekWz = ({ wz, aktywnyFiltr, onFiltr }) => {
  if (!wz) return null;
  const n = (k) => (wz[k] === null || wz[k] === undefined ? '—' : wz[k]);
  const aktywny = aktywnyFiltr === 'wz_bez_faktury';
  const el = (etykieta, wartosc, kolor) => (
    <span style={{ whiteSpace: 'nowrap' }}>
      <span style={{ fontWeight: 700, color: kolor || 'var(--text)' }}>{wartosc}</span>{' '}
      <span style={{ color: 'var(--text-secondary)' }}>{etykieta}</span>
    </span>
  );
  return (
    <div data-testid="pasek-wz" style={{
      display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '14px', marginTop: '8px', padding: '6px 10px',
      borderRadius: '4px', fontSize: '11px', backgroundColor: 'var(--bg)', borderLeft: '3px solid var(--orange)',
    }}>
      <span style={{ fontWeight: 600, color: 'var(--orange)' }}>WZ z portalu</span>
      {el('w portalu', n('w_portalu'))}
      {el('z fakturą', n('z_faktura'), 'var(--success)')}
      <button
        type="button"
        data-testid="wz-bez-faktury"
        aria-pressed={aktywny}
        onClick={() => onFiltr && onFiltr('wz_bez_faktury')}
        title="Pokaż WZ, do których portal nie wystawił jeszcze faktury"
        style={{
          padding: '2px 8px', fontSize: '11px', fontWeight: 600, borderRadius: '10px', cursor: 'pointer',
          border: '1px solid var(--orange)',
          background: aktywny ? 'var(--orange)' : 'var(--card-bg)',
          color: aktywny ? '#fff' : 'var(--orange)',
        }}
      >
        {n('bez_faktury')} bez faktury
      </button>
      {el('w systemie bez faktury', n('w_systemie_bez_faktury'), Number(wz.w_systemie_bez_faktury) > 0 ? 'var(--warning)' : 'var(--text-muted)')}
    </div>
  );
};

export default PasekWz;
